export default "__VITE_ASSET__DpbJO7Zz__"